<div class="custom-mat-dialog-form">
  <div>
    <h3>
      Manage Controller Config Predefined Items Description
    </h3>
  </div>
  <div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="mt-2">
        <label>PredefinedItemBK *</label>
        <div class="input">
          <div class="input">
            <input type="text"
              [(ngModel)]="body.PredefinedItemBk" class="form-control" formControlName="PredefinedItemBk"
              [ngClass]="{ 'is-invalid': submitted && f['PredefinedItemBk'].errors }" />
              @if (submitted && f['PredefinedItemBk'].errors) {
                <div class="invalid-feedback">
                  <div class="error-div">PredefinedItemBk was not populated</div>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="mt-2 right">
          <button type="button"
            class="btn btn-danger"
            (click)="onNoClick()">
            Close
          </button>
          <button type="button"
            class="btn btn-primary"
            (click)="onSubmit()">
            Send
          </button>
        </div>
      </form>
    </div>
  </div>
